import { Component } from '@angular/core';

@Component({
    selector : 'how-to-use',
    templateUrl : './how-to-use.component.html',
    styleUrls : ['./how-to-use.component.css']
})
export class HowToUseComponent {

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/poster/how-to-use/how-to-use.component.ts